import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import Box from '@mui/material/Box';
import { cloneElement } from 'react';
import { useTouchClick } from '../../hooks';
import { useTheme } from '../../theme';
import { Tooltip } from '../tooltip';
import { getBaseStyles, getDestructiveStylesForType, getStylesBySize, getStylesByType } from './iconButton.styles';
export const IconButton = ({ icon, size = 'small', disabled = false, onClick, type = 'default', innerRef, title, destructive = false, themeName, tooltipPlacement = 'top', active = false, iconType = 'stroke', canShowTooltip = true, ...rest })=>{
    const theme = useTheme(themeName);
    const handleClick = (event)=>{
        if (disabled) {
            return;
        }
        void onClick?.(event);
    };
    const { handleTouchStart, handleTouchMove, handleTouchEnd } = useTouchClick({
        onClick: onClick ? handleClick : undefined
    });
    const button = /*#__PURE__*/ _jsx("button", {
        "aria-label": title,
        ...rest,
        disabled: disabled,
        onClick: handleClick,
        onTouchStart: handleTouchStart,
        onTouchMove: handleTouchMove,
        onTouchEnd: handleTouchEnd,
        type: "button",
        ref: innerRef,
        css: {
            ...getBaseStyles(theme),
            ...getStylesBySize(size, theme),
            ...getStylesByType(type, active, theme),
            ...destructive ? getDestructiveStylesForType(type, active, theme) : {},
            cursor: disabled ? 'not-allowed' : 'pointer'
        },
        children: /*#__PURE__*/ cloneElement(icon, {
            type: iconType
        })
    });
    if (Boolean(title) && canShowTooltip) {
        return /*#__PURE__*/ _jsx(Tooltip, {
            placement: tooltipPlacement,
            title: title,
            offset: -4,
            children: /*#__PURE__*/ _jsx(Box, {
                sx: {
                    display: 'flex'
                },
                children: button
            })
        });
    }
    return button;
};

//# sourceMappingURL=iconButton.js.map